<script lang="ts">
    import { faIcon } from '@js/fa-icons'

    export let name
    export let prefix = 'fas'
</script>

<!-- eslint-disable svelte/no-at-html-tags -->
{@html faIcon(name, prefix)?.html }
